var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#profile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.714a4.286 4.286 0 1 0 0-8.571 4.286 4.286 0 0 0 0 8.571M4.68 20.4a8.572 8.572 0 0 1 14.64 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23.143c6.154 0 11.143-4.989 11.143-11.143S18.154.857 12 .857.857 5.846.857 12 5.847 23.143 12 23.143"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "profile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgProfile;